import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { DeleteConfirmationDialogProps } from "./types";

export const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  open,
  handleClose,
  handleAction,
}) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>DELETE</DialogTitle>
      <DialogContent>
        <DialogContentText>
          ¿ Are you sure you want to delete this item ?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          CANCEL
        </Button>
        <Button onClick={handleAction} color="primary">
          YES
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
